
import { Language } from '@/contexts/language';
import { StatisticsKeys } from "../types/statistics";
import { TranslationSet } from '../types/base';

// Define the statistics translations with proper structure
export const statistics: TranslationSet = {
  'statistics.title': {
    en: "Baby's Growth Journey",
    ja: '赤ちゃんの成長統計',
    es: 'Estadísticas de Crecimiento del Bebé',
    zh: '婴儿成长统计',
    fa: 'آمار رشد کودک'
  },
  'statistics.subtitle': {
    en: 'Watch your little one grow and develop over time',
    ja: '時間の経過とともに赤ちゃんの成長と発達を追跡する',
    es: 'Rastrea el crecimiento y desarrollo de tu bebé a lo largo del tiempo',
    zh: '随时间追踪婴儿的成长和发育',
    fa: 'پیگیری رشد و تکامل کودک شما در طول زمان'
  },
  'statistics.entriesCount': {
    en: 'Diary Entries',
    ja: '日記エントリー',
    es: 'Entradas de Diario',
    zh: '日记条目',
    fa: 'مدخل‌های روزانه'
  },
  'statistics.imagesUploaded': {
    en: 'Images Uploaded',
    ja: 'アップロードされた画像',
    es: 'Imágenes Subidas',
    zh: '已上传图片',
    fa: 'تصاویر آپلود شده'
  },
  'statistics.averageMood': {
    en: 'Average Mood',
    ja: '平均的な気分',
    es: 'Estado de Ánimo Promedio',
    zh: '平均心情',
    fa: 'خلق و خوی متوسط'
  },
  'statistics.selectTimeRange': {
    en: 'Show data for',
    ja: 'データを表示する期間',
    es: 'Mostrar datos de',
    zh: '显示数据',
    fa: 'نمایش داده‌ها برای'
  },
  'statistics.lastMonth': {
    en: 'Last month',
    ja: '先月',
    es: 'Último mes',
    zh: '上个月',
    fa: 'ماه گذشته'
  },
  'statistics.lastThreeMonths': {
    en: 'Last 3 months',
    ja: '過去3ヶ月',
    es: 'Últimos 3 meses',
    zh: '最近3个月',
    fa: '3 ماه گذشته'
  },
  'statistics.lastSixMonths': {
    en: 'Last 6 months',
    ja: '過去6ヶ月',
    es: 'Últimos 6 meses',
    zh: '最近6个月',
    fa: '6 ماه گذشته'
  },
  'statistics.lastYear': {
    en: 'Last year',
    ja: '去年',
    es: 'Último año',
    zh: '去年',
    fa: 'سال گذشته'
  },
  'statistics.allTime': {
    en: 'All time',
    ja: '全期間',
    es: 'Todo el tiempo',
    zh: '所有时间',
    fa: 'تمام زمان‌ها'
  },
  'statistics.height': {
    en: 'Height',
    ja: '身長',
    es: 'Altura',
    zh: '身高',
    fa: 'قد'
  },
  'statistics.weight': {
    en: 'Weight',
    ja: '体重',
    es: 'Peso',
    zh: '体重',
    fa: 'وزن'
  },
  'statistics.milk': {
    en: 'Milk Intake',
    ja: 'ミルク摂取量',
    es: 'Consumo de Leche',
    zh: '奶量摄入',
    fa: 'مصرف شیر'
  },
  'statistics.heightChartTitle': {
    en: 'Growing Taller!',
    ja: '身長成長チャート',
    es: 'Gráfico de Crecimiento de Altura',
    zh: '身高增长图表',
    fa: 'نمودار رشد قد'
  },
  'statistics.weightChartTitle': {
    en: 'Getting Bigger!',
    ja: '体重成長チャート',
    es: 'Gráfico de Crecimiento de Peso',
    zh: '体重增长图表',
    fa: 'نمودار رشد وزن'
  },
  'statistics.milkIntakeChartTitle': {
    en: 'Yummy Milk!',
    ja: 'ミルク摂取量チャート',
    es: 'Gráfico de Consumo de Leche',
    zh: '奶量摄入图表',
    fa: 'نمودار مصرف شیر'
  },
  'statistics.noDataAvailable': {
    en: 'No growth data available yet. Time to measure your little one!',
    ja: '成長データはまだ利用できません',
    es: 'Aún no hay datos de crecimiento disponibles',
    zh: '暂无可用的成长数据',
    fa: 'هنوز داده‌های رشد در دسترس نیست'
  },
  'statistics.showAverage': {
    en: 'Show average',
    ja: '平均を表示',
    es: 'Mostrar promedio',
    zh: '显示平均值',
    fa: 'نمایش میانگین'
  },
  'statistics.switchTo': {
    en: 'Switch to',
    ja: '切り替える',
    es: 'Cambiar a',
    zh: '切换到',
    fa: 'تغییر به'
  },
  'statistics.metric': {
    en: 'metric',
    ja: 'メートル法',
    es: 'métrico',
    zh: '公制',
    fa: 'متری'
  },
  'statistics.imperial': {
    en: 'imperial',
    ja: 'ヤード・ポンド法',
    es: 'imperial',
    zh: '英制',
    fa: 'امپریال'
  },
  'statistics.heightGrowth': {
    en: 'Height Growth',
    ja: '身長の成長',
    es: 'Crecimiento de Altura',
    zh: '身高增长',
    fa: 'رشد قد'
  },
  'statistics.heightProgress': {
    en: 'See how tall your little one is getting!',
    ja: '赤ちゃんの身長の変化を時間とともに追跡',
    es: 'Rastrea cómo ha cambiado la altura de tu bebé con el tiempo',
    zh: '追踪您宝宝随时间的身高变化',
    fa: 'پیگیری تغییرات قد کودک شما در طول زمان'
  },
  'statistics.weightGrowth': {
    en: 'Weight Growth',
    ja: '体重の成長',
    es: 'Crecimiento de Peso',
    zh: '体重增长',
    fa: 'رشد وزن'
  },
  'statistics.weightProgress': {
    en: 'Watch your baby grow bigger and stronger!',
    ja: '赤ちゃんの体重の変化を時間とともに追跡',
    es: 'Rastrea cómo ha cambiado el peso de tu bebé con el tiempo',
    zh: '追踪您宝宝随时间的体重变化',
    fa: 'پیگیری تغییرات وزن کودک شما در طول زمان'
  },
  'statistics.milkIntake': {
    en: 'Milk Intake',
    ja: 'ミルク摂取量',
    es: 'Consumo de Leche',
    zh: '奶量摄入',
    fa: 'مصرف شیر'
  },
  'statistics.milkIntakeProgress': {
    en: 'See how much yummy milk your baby is drinking!',
    ja: '赤ちゃんのミルク摂取量の変化を時間とともに追跡',
    es: 'Rastrea cómo ha cambiado el consumo de leche de tu bebé con el tiempo',
    zh: '追踪您宝宝随时间的奶量摄入变化',
    fa: 'پیگیری تغییرات مصرف شیر کودک شما در طول زمان'
  },
  'statistics.editBabyProfile': {
    en: 'Edit Baby Profile',
    ja: '赤ちゃんのプロフィールを編集',
    es: 'Editar Perfil del Bebé',
    zh: '编辑宝宝资料',
    fa: 'ویرایش نمایه کودک'
  },
  'statistics.editFamilyProfile': {
    en: 'Edit Family Profile',
    ja: '家族のプロフィールを編集',
    es: 'Editar Perfil Familiar',
    zh: '编辑家庭资料',
    fa: 'ویرایش نمایه خانواده'
  },
  'statistics.birthHeight': {
    en: 'Birth Height',
    ja: '出生時の身長',
    es: 'Altura al Nacer',
    zh: '出生身高',
    fa: 'قد هنگام تولد'
  },
  'statistics.birthWeight': {
    en: 'Birth Weight',
    ja: '出生時の体重',
    es: 'Peso al Nacer',
    zh: '出生体重',
    fa: 'وزن هنگام تولد'
  },
  'statistics.addMeasurementsInDiary': {
    en: 'Add height, weight, or milk intake in diary entries to see fun charts here!',
    ja: '日記エントリーを作成するときに身長、体重、ミルク摂取量情報を追加して、ここに視覚化されたものを確認できます。',
    es: 'Agrega información de altura, peso o consumo de leche al crear entradas de diario para verlas visualizadas aquí.',
    zh: '在创建日记条目时添加身高、体重或奶量摄入信息，以便在此处可视化查看。',
    fa: 'اطلاعات قد، وزن یا مصرف شیر را هنگام ایجاد مدخل‌های روزانه اضافه کنید تا در اینجا به صورت تصویری مشاهده شوند.'
  }
};
